import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { ReactivateCustomerMutationMutation, ReactivateCustomerMutationMutationVariables } from "../../../schemaTypes";
import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";

export const reactivateCustomerMutation = gql`
  mutation ReactivateCustomerMutation($email: String!) {
    reactivateCustomer(email: $email) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitReactivateCustomer: (
        values: ReactivateCustomerMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const ReactivateCustomerController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    ReactivateCustomerMutationMutation,
    ReactivateCustomerMutationMutationVariables
  >(reactivateCustomerMutation);

  const submitReactivateCustomer = async (
    values: ReactivateCustomerMutationMutationVariables
  ) => {
    const response = await mutate({ variables: values });

    const reactivateCustomer = response?.data?.reactivateCustomer;

    if (reactivateCustomer?.errors) {
      return normalizeErrors(reactivateCustomer.errors);
    }

    return null;
  };

  const message = data?.reactivateCustomer?.message || null;

  return children({
    submitReactivateCustomer,
    loading,
    error,
    message,
  });
};
